<template>
  <BLayoutView
    :back-route="backRoute"
    :edit-route="editRoute"
    :title="pageTitle"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    :hidden-footer="viewTypeOptions.isView"

    :editable="editable"
    :deletable="deletable"

    @delete="onDelete(single)"
    @save-menu="onSave"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :loading="isLoading"
        :data="viewTypeOptions.isCreate ? void 0 : single"
        :skeleton="isLoadingAsyncData"
        @save="onSave"
      />
    </template>

    <template v-if="!viewTypeOptions.isCreate" #footer.left>
      <v-skeleton-loader :loading="isLoadingAsyncData" type="button">
        <v-btn
          depressed
          @click="onDownloadList(single)"
          v-text="'Выгрузить'"
        />
      </v-skeleton-loader>
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { ParticipantsModel as Model } from './Model'
import { participantsMapper as StoreMapper, participantsStoreModule as StoreModule } from './store'
import { PARTICIPANTS_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import ComponentForm from './components/ParticipantsForm.vue'


const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'ViewParticipantsView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    ComponentForm,
  },
  mixins: [
    viewMixin,
    deletableMixin,
  ],
  data: () => ({
    backRoute: { name: ROUTES.LIST },
  }),
  computed: {
    createRoute() {
      return {
        name: ROUTES.CREATE,
      }
    },
    editRoute() {
      return {
        name: ROUTES.EDIT,
        props: { id: this.id },
      }
    },
  },
  /** @type { View & Deletable } */
  methods: {
    ...StoreMapper.mapActions(['exportParticipantUsers']),
    async onSave(type) {
      const form = await this.$refs.form.onSubmit()
      const result = await this.onSubmit(form)
      this.$refs.form.onReset()

      const { id } = result
      const editRoute = { name: ROUTES.EDIT, params: { id } }
      this.toSave(this.backRoute, this.createRoute, editRoute, type)
    },
    async onDelete(data) {
      const result = await this.toDelete(data)
      if (!result) return
      this.$router.replace(this.backRoute)
    },
    onDownloadList({ id }) {
      this.isLoading = true

      try {
        this.exportParticipantUsers({ id })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
